interface ErrorBoxProps {
  message: string;
  /** Co ham thi hien nut "Thu lai" — moi loi mang deu nen thu lai duoc mot cach. */
  onRetry?: () => void;
  title?: string;
}

export function ErrorBox({ message, onRetry, title }: ErrorBoxProps) {
  return (
    <div
      role="alert"
      className="rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-800 dark:border-red-900 dark:bg-red-950 dark:text-red-200"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-semibold">{title ?? 'Không tải được dữ liệu'}</p>
          <p className="mt-1 break-words">{message}</p>
        </div>
        {onRetry !== undefined && (
          <button type="button" className="cf-btn cf-btn-ghost shrink-0" onClick={onRetry}>
            Thu lai
          </button>
        )}
      </div>
    </div>
  );
}

interface EmptyBoxProps {
  message: string;
  hint?: string;
}

export function EmptyBox({ message, hint }: EmptyBoxProps) {
  return (
    <div className="rounded-md border border-dashed border-slate-300 p-6 text-center dark:border-slate-700">
      <p className="text-sm font-medium text-slate-600 dark:text-slate-300">{message}</p>
      {hint !== undefined && (
        <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{hint}</p>
      )}
    </div>
  );
}
